import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";

import { yellow } from "@mui/material/colors";
import { getDisplaySize } from "../../utils/Items";
import { Dialog, Typography } from "@mui/material";

// 商品明細削除ダイアログ
export default function DeleteChainStoreProductDialog({
  open,
  onCloseDialog,
  chainStoreProduct,
  deleteAction,
}) {
  const nullData = {
    productId: "",
    customerId: "",
    chainStoreProductTypeCd: "",
    chainStoreProductCd: "",
    chainStoreProductName: "",
  };

  const {
    productId,
    customerId,
    chainStoreProductTypeCd,
    chainStoreProductCd,
    chainStoreProductName,
  } = chainStoreProduct ? chainStoreProduct : nullData;

  const onClickDelete = (event) => {
    deleteAction();
    alert(
      "以下のチェーンストア商品を削除しました。\n" +
        `チェーンストア商品名: ${chainStoreProductName}\n` +
        `チェーンストア商品コード: ${chainStoreProductCd}\n`
    );
    onCloseDialog(event);
  };

  const onCloseCancel = (event) => {
    onCloseDialog(event);
  };

  return (
    <Dialog open={open} onClose={onCloseCancel}>
      <Box padding={2} minWidth={400}>
        <Typography fontSize={20} fontWeight={700}>
          削除
        </Typography>
        <Box marginTop={2} marginBottom={1}>
          <Typography>
            チェーンストア商品一覧から、以下の商品を削除します。
          </Typography>
          <Box backgroundColor={yellow[100]} marginY={1} padding={1}>
            <Typography fontSize={20}>
              チェーンストア商品名:&nbsp;{chainStoreProductName}
            </Typography>
            <Typography fontSize={20}>
              チェーンストア商品コード:&nbsp;{chainStoreProductCd}
            </Typography>
          </Box>
        </Box>

        <Grid container>
          <Grid item xs textAlign="center">
            <Button variant="contained" color="error" onClick={onClickDelete}>
              削除
            </Button>
          </Grid>
          <Grid item xs textAlign="center">
            <Button variant="outlined" onClick={onCloseCancel}>
              戻る
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Dialog>
  );
}
